<script lang="ts" setup>
import { onBeforeMount } from 'vue'

import { authLinks } from '@js/utils/links'
import useAuth from '@js/composables/useAuth'
import { withReturnPath } from '@js/utils/returnPath'

defineOptions({
  name: 'AppAuthChecker',
  render: () => null,
})

const props = withDefaults(
  defineProps<{
    redirectPath?: string
    contextForAccess?: 'authenticated' | 'unauthenticated'
    returnAfterLogin?: boolean
  }>(),
  {
    redirectPath: authLinks.LOGIN,
    contextForAccess: 'authenticated',
    returnAfterLogin: false,
  },
)

const { isLoggedIn } = useAuth()

const handleRedirect = (): void => {
  window.location.assign(
    props.returnAfterLogin ? withReturnPath(props.redirectPath) : props.redirectPath,
  )
}

onBeforeMount(() => {
  if (props.contextForAccess === 'authenticated' && !isLoggedIn.value) {
    handleRedirect()

    return
  }

  if (props.contextForAccess === 'unauthenticated' && isLoggedIn.value) {
    handleRedirect()

    return
  }
})
</script>
